import { render, staticRenderFns } from "./AddTeachingAndResearch.vue?vue&type=template&id=3d71ca2c&scoped=true"
import script from "./AddTeachingAndResearch.vue?vue&type=script&lang=js"
export * from "./AddTeachingAndResearch.vue?vue&type=script&lang=js"
import style0 from "./AddTeachingAndResearch.vue?vue&type=style&index=0&id=3d71ca2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d71ca2c",
  null
  
)

export default component.exports